import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { AbstractInteractorTool } from './tools';
import { RouteInteractors } from './interactors';
import { EditRoutes } from './../cmd/EditRoutes';
import { RouteEnding } from "../mdl/Route";
import { RouteSnapping } from './RouteSnapping';
import { Util } from "../utils/Util";
export class MoveRoute extends AbstractInteractorTool {
    constructor(pRoomManager) {
        super(pRoomManager);
        this.mCommand = null;
    }
    initialize(pMode, pRoute) {
        this.mMode = pMode;
        this.mRoute = pRoute;
        this.mRouteDirections = pRoute._getConnectedRouteDirections();
        this.mCommand = new EditRoutes(this.mRoomManager);
        this.mRouteSnapping = new RouteSnapping(this.mRoomManager);
        this.prepareSnapping();
        //this.mRoomManager.beginInteraction();
    }
    stop() {
        if (this.mCommand != null) {
            this.mCommand.cancel();
            this.mCommand = null;
        }
        this.mRoomManager.endInteraction();
        super.stop();
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    startPos(pPos) {
        //
    }
    updatePointerPosition(pPos) {
        let tPos = this.performSnapping(pPos);
        this.mCurrentPos = Util.to2d(tPos);
        let tnewPos = new Vector3(0, 0, 0);
        switch (this.mMode) {
            case MoveRoute.Mode.MoveStart:
                tnewPos = Util.to3d(this.mCurrentPos);
                if (this.mRoomManager.shiftPressed) {
                    let tStart = Util.to3d(this.mRoute.endPoint);
                    tnewPos = Util.calcSnapPoint(tStart, tnewPos, 45);
                }
                this.mRoute.setStartPoint(Util.to2d(tnewPos));
                break;
            case MoveRoute.Mode.MoveEnd:
                tnewPos = Util.to3d(this.mCurrentPos);
                if (this.mRoomManager.shiftPressed) {
                    let tStart = Util.to3d(this.mRoute.startPoint);
                    tnewPos = Util.calcSnapPoint(tStart, tnewPos, 45);
                }
                this.mRoute.setEndPoint(Util.to2d(tnewPos));
                break;
            case MoveRoute.Mode.MoveRoute:
                let tCenter = Vector2.Center(this.mRoute.startPoint, this.mRoute.endPoint);
                this.mRoute.moveRoute(this.mCurrentPos.subtract(tCenter));
                break;
            default:
                break;
        }
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    finish() {
        //setup connection
        if (this.mMode !== MoveRoute.Mode.MoveRoute) {
            let tEnding = this.mMode === MoveRoute.Mode.MoveStart ? RouteEnding.Start :
                RouteEnding.End;
            this.mRoute._findNewConnection(tEnding);
        }
        this.mRoute._handleFlippedRoutes(this.mRouteDirections);
        this.mRoute._validateConnections(2);
        if (this.mCommand != null) {
            this.mApp.commands.executeCommand(this.mCommand).then(() => {
                this.mCommand = null;
                this.stop();
            });
        }
    }
    prepareSnapping() {
        super.prepareSnapping();
        if (this.mMode !== MoveRoute.Mode.MoveRoute) {
            this.mRouteSnapping.prepareSnapping(this.mRoute, this.mMode === MoveRoute.Mode.MoveStart ?
                RouteEnding.End : RouteEnding.Start);
        }
    }
    prepareFeedback() {
        super.prepareFeedback();
        this.mLengthFeedback = new RouteInteractors(this.mRoomManager, this.mRoute);
        this.mLengthFeedback._updateLengthInteractors();
    }
    updateFeedback() {
        super.updateFeedback();
        if (this.mLengthFeedback != null)
            this.mLengthFeedback._updateLengthInteractors();
    }
    clearFeedback() {
        super.clearFeedback();
        this.mRouteSnapping.clear();
        if (this.mLengthFeedback != null) {
            this.mLengthFeedback.clear();
            this.mLengthFeedback = null;
        }
    }
    performSnapping(pPos) {
        return (this.mRouteSnapping.snap(pPos, this.mView));
    }
}
//add nested types
(function (MoveRoute) {
    let Mode;
    (function (Mode) {
        Mode[Mode["MoveStart"] = 0] = "MoveStart";
        Mode[Mode["MoveEnd"] = 1] = "MoveEnd";
        Mode[Mode["MoveRoute"] = 2] = "MoveRoute";
    })(Mode = MoveRoute.Mode || (MoveRoute.Mode = {}));
})(MoveRoute || (MoveRoute = {}));
